export default [
  {
    title: 'Inbox',
    route: 'contacts-list',
    icon: 'InboxIcon',
  },
]
